import { useEffect, useState } from "react";
import { ArrowUpRight, Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

export default function Competitions() {
  const [items, setItems] = useState([]);
  const [season, setSeason] = useState("2026/2027");
  useEffect(() => {
    api.get("/competitions").then((r) => setItems(r.data)).catch(() => {});
    api.get("/settings").then((r) => r.data?.current_season && setSeason(r.data.current_season)).catch(() => {});
  }, []);

  const groups = [
    { key: "seniors", title: "Súťaže dospelých", items: items.filter((c) => c.category === "seniors") },
    { key: "youth", title: "Mládežnícke súťaže", items: items.filter((c) => c.category === "youth") },
    { key: "cup", title: "Pohárové súťaže", items: items.filter((c) => c.category === "cup") },
  ];

  return (
    <div data-testid="competitions-page">
      <Seo title="Súťaže" description={`Oblastné súťaže ObFZ Levice — VII. a VIII. liga dospelých, mládežnícke a pohárové súťaže sezóny ${season}.`} />
      <PageHeader
        eyebrow={`Sezóna ${season}`}
        title="Oblastné súťaže"
        description="Prehľad oblastných súťaží — VII. liga, VIII. liga, mládežnícke súťaže a pohárové stretnutia. Výsledky a tabuľky sú v oficiálnom systéme Futbalnet."
        breadcrumbs={[{ label: "Súťaže" }]}
      />

      <section className="section-pad bg-paper">
        <div className="wrap">
          {groups.map((g, gi) =>
            g.items.length === 0 ? null : (
              <div key={g.key} className={gi > 0 ? "mt-16" : ""}>
                <h2 className="display-md mb-8 border-b-2 border-ink-900 pb-4">{g.title}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink-100 border border-ink-100">
                  {g.items.map((c, i) => (
                    <article key={c.id} className="bg-white p-7 hover:bg-cream transition-colors" data-testid={`competition-detail-${c.id}`}>
                      <div className="flex items-start justify-between mb-5">
                        <div>
                          <span className="mono text-[11px] font-bold uppercase tracking-widest text-green-700">
                            0{i + 1}/ {g.title.split(" ")[0]}
                          </span>
                          <h3 className="font-heading font-extrabold text-ink-900 text-2xl md:text-3xl mt-2 tracking-tight leading-tight">
                            {c.name}
                          </h3>
                        </div>
                        <div className="w-12 h-12 border-2 border-ink-900 flex items-center justify-center flex-shrink-0">
                          <Trophy className="w-5 h-5 text-ink-900" />
                        </div>
                      </div>
                      <p className="text-sm text-ink-500 leading-relaxed mb-5">{c.description}</p>
                      <div className="flex flex-wrap gap-2">
                        {c.results_url && <a href={c.results_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-2 border border-ink-200 hover:bg-ink-900 hover:text-white hover:border-ink-900 mono text-[11px] font-bold uppercase tracking-widest transition-all">Výsledky <ArrowUpRight className="w-3 h-3" /></a>}
                        {c.table_url && <a href={c.table_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-2 border border-ink-200 hover:bg-ink-900 hover:text-white hover:border-ink-900 mono text-[11px] font-bold uppercase tracking-widest transition-all">Tabuľka <ArrowUpRight className="w-3 h-3" /></a>}
                        {c.schedule_url && <a href={c.schedule_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-2 border border-ink-200 hover:bg-ink-900 hover:text-white hover:border-ink-900 mono text-[11px] font-bold uppercase tracking-widest transition-all">Rozpis <ArrowUpRight className="w-3 h-3" /></a>}
                        {c.documents_url && <Link to={c.documents_url} className="inline-flex items-center gap-1.5 px-3 py-2 border border-ink-200 hover:bg-ink-900 hover:text-white hover:border-ink-900 mono text-[11px] font-bold uppercase tracking-widest transition-all">Dokumenty</Link>}
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </section>
    </div>
  );
}
